/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_TInputs */

const en_cp_lead_get_t = /** @type {(inputs: Cp_Lead_Get_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you get`)
};

const id_cp_lead_get_t = /** @type {(inputs: Cp_Lead_Get_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang kamu dapat`)
};

/**
* | output |
* | --- |
* | "What you get" |
*
* @param {Cp_Lead_Get_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_t = /** @type {((inputs?: Cp_Lead_Get_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_t(inputs)
	return en_cp_lead_get_t(inputs)
});